import {
  CLEAR_FORM_ELEMENTS,
  COPY_FORM_ELEMENTS,
} from './constants'
import {
  updateObject,
  createReducer,
} from 'helpers/ReducerUtil'
import validationReducer from 'containers/Form/Validation/reducer'
import projectReducer from 'containers/Form/Project/reducer'

const copyFormElements = (elements, action) => {
   return updateObject(elements, action.elements)}
const clearFormElements = () => ({})

// Special reducers to be imported within entity reducer for handling seperate
// changes as it requires shared entity values
const formReducer = createReducer({}, {
  [COPY_FORM_ELEMENTS]: copyFormElements,
  [CLEAR_FORM_ELEMENTS]: clearFormElements,
})

export { riskValidationReducer } from 'containers/Form/RiskValidation/reducer'
export {
  formReducer,
  validationReducer,
  projectReducer
}
